var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',{staticClass:"PageHeader",class:_vm.backgroundClass,style:({
      'background-image': ("url('" + (_vm.image.filename) + "/m/1500x500/smart')")
    }),attrs:{"fluid":""}},[_c('b-container',{staticClass:"align-self-center"},[_c('h1',{staticClass:"text-center",class:_vm.textClass},[_vm._v(" "+_vm._s(_vm.headline)+" ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }